import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/protected-route";
import { NotFoundInLayout } from "@/components/reusable-components/not-found";
import { AppSidebar } from "@/components/sidebar/app-sidebar-admin";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useCommandMenuShortcut } from "@/hooks/use-command-menu-shortcut";
import { CommandMenu } from "@/components/command-menu";
import { useAuthStore } from "@/stores/useAuthStore";
import { useEffect } from "react";
import { auth } from "@/lib/auth";
import { useOrganizationStore } from "@/stores/useOrganizationStore";
import { useFeatureStore } from "@/stores/useFeatureStore";
import { useOrgSettingsStore } from "@/stores/useOrgSettingsStore";

export const Route = createFileRoute("/admin/_layout")({
  beforeLoad: async () => {
    await useFeatureStore.getState().fetchFeatures();
    await useOrgSettingsStore.getState().fetchSettings();
  },
  component: AdminDashboard,
  notFoundComponent: NotFoundInLayout,
});

function AdminDashboard() {
  const { organizationTimezone, fetchTimezone, fetchOrgSlug, orgSlug, isLoading, error } =
    useOrganizationStore();

  useEffect(() => {
    if (!organizationTimezone && !isLoading && !error) {
      fetchTimezone();
    }
  }, [organizationTimezone, fetchTimezone, isLoading, error]);

  useEffect(() => {
    if (!orgSlug) {
      fetchOrgSlug();
    }
  }, [orgSlug, fetchOrgSlug]);
  const { getProfile, user } = useAuthStore();

  useEffect(() => {
    const token = auth.getToken();
    if (token && !user) {
      getProfile();
    }
  }, [getProfile, user]);
  useCommandMenuShortcut();
  return (
    // The admin shell no longer means "is an admin" — it means "holds
    // something beyond the baseline". An accountant and a storekeeper both
    // reach it; the sidebar then shows each of them only their own section.
    <ProtectedRoute requiresAnyCapability redirectTo="/login">
      <SidebarProvider>
        <AppSidebar />
        <CommandMenu />
        <Outlet />
      </SidebarProvider>
    </ProtectedRoute>
  );
}
